'use client';

import { DestinationMarketplaceValue, PARTNER_NETWORK_MARKETPLACES } from '@/types/auction';
import { H6 } from '@liveauctioneers/hammer-ui-core/text';
import { PartnerNetworkRow } from './PartnerNetworkRow';
import { useId } from 'react';
import { useTranslations } from 'next-intl';

type PartnerNetworkEnablementGroupProps = Readonly<{
    disabled: boolean;
    onToggle: (code: DestinationMarketplaceValue, isEnabled: boolean) => Promise<void> | void;
    selectedValues: readonly DestinationMarketplaceValue[];
}>;

export const PartnerNetworkEnablementGroup = ({
    disabled,
    onToggle,
    selectedValues,
}: PartnerNetworkEnablementGroupProps) => {
    const headingId = useId();
    const t = useTranslations('AdminToolbar.crossListing');

    return (
        <fieldset
            aria-labelledby={headingId}
            className="mt-md border-0 p-0"
        >
            <H6
                className="mb-xs uppercase"
                color="secondary"
                id={headingId}
            >
                {t('partnerNetworkHeading')}
            </H6>
            <div className="divide-y divide-border-secondary overflow-hidden rounded-md border border-border-secondary">
                {PARTNER_NETWORK_MARKETPLACES.map(({ code, translationKey }) => {
                    const label = t(translationKey);

                    return (
                        <PartnerNetworkRow
                            code={code}
                            disabled={disabled}
                            isToggled={selectedValues.includes(code)}
                            key={code}
                            label={label}
                            onToggle={onToggle}
                        />
                    );
                })}
            </div>
        </fieldset>
    );
};

PartnerNetworkEnablementGroup.displayName = 'PartnerNetworkEnablementGroup';
